/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useState, useEffect} from "react";


import {Col, Row, Form, Button} from "react-bootstrap";

import {useDispatch} from "react-redux";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import ApplicationApiContext from "@Contexts/Api";

import PRODUCT_INTERFACE from "@Services/Application/Interfaces/Products/Product";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import ERROR_SYSTEM_MESSAGE_INTERFACE from "@Services/Application/Interfaces/_Messages/Errors";
import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import {MdCancel, MdChangeCircle} from "react-icons/all";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";



type CompartmentProductReceiversProps = {
    PRODUCT_RECEIVER_ID: string;
    PRODUCT_RECEIVER_HANDLER: any;
    PRODUCT_DATA?: PRODUCT_INTERFACE | null;
    editable?: boolean;
};

export const CompartmentProductReceiversComponent: React.FC<CompartmentProductReceiversProps> = ({
    PRODUCT_RECEIVER_ID, PRODUCT_RECEIVER_HANDLER, PRODUCT_DATA = null,
    editable = true
}): JSX.Element | null => {


    const DISPATCHER = useDispatch();


    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL || null;


    /** @const {object} REST_API_DATA - Application State Store Rest Api Data */
    const REST_API_DATA:ReturnType<any> = useTypedSelector(
        (state) => state.api
    );

    /** @const {AUTHORIZATION_TOKEN_INTERFACE} REST_API_REQUEST_TOKEN - Application Rest Api Request Token */
    const REST_API_REQUEST_TOKEN: AUTHORIZATION_TOKEN_INTERFACE = REST_API_DATA?.requestToken || null;



    const [PRODUCT_RECEIVER_CHANGE_STATUS, SET_PRODUCT_RECEIVER_CHANGE_STATUS] = useState<boolean>(false);

    const CHANGE_PRODUCT_RECEIVER_CHANGE_STATUS = (status: boolean) => {
        if (status === false) {
            SET_PRODUCT_RECEIVER(PRODUCT_RECEIVER_ID);
            SET_PRODUCT_RECEIVERS([]);
            SET_PRODUCT_RECEIVER_ERROR(null);
        }
        SET_PRODUCT_RECEIVER_CHANGE_STATUS(status);
    };

    const [PRODUCT_RECEIVER, SET_PRODUCT_RECEIVER] = useState<string>(PRODUCT_RECEIVER_ID || "BRAK");
    const [PRODUCT_RECEIVERS, SET_PRODUCT_RECEIVERS] = useState<[] | null>([]);
    const [PRODUCT_RECEIVER_ERROR, SET_PRODUCT_RECEIVER_ERROR] = useState<ERROR_SYSTEM_MESSAGE_INTERFACE | null>(null);

    useEffect(() => {
        SET_PRODUCT_RECEIVER(PRODUCT_RECEIVER_ID);
    }, [PRODUCT_RECEIVER_ID, PRODUCT_DATA]);

    useEffect(() => {
        CHANGE_PRODUCT_RECEIVER_CHANGE_STATUS(false);
    }, [PRODUCT_DATA]);

    const [productReceiversFilter, setProductReceiversFilter] = useState<string>("");

    useEffect(() => {

        if (!PRODUCT_RECEIVER_CHANGE_STATUS) return;

        //if (!REST_API_URL || !LOGGED_USER?.userID || !PRODUCT_RECEIVER) return;
        if (!REST_API_URL || !LOGGED_USER?.userID) return;


        const GET_PRODUCT_RECEIVERS = async () => {

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

            try {

                const RECEIVERS_RESPONSE = await REST_API_REQUEST(
                    `${REST_API_URL}/TransportNotification/Receiver/List`,
                    {
                        UserId: LOGGED_USER?.userID,
                        DispNo: PRODUCT_DATA?.DispNo,
                        DispPos: PRODUCT_DATA?.Pos,
                        FilterString: productReceiversFilter
                    },
                    REST_API_REQUEST_TOKEN
                );

                if (RECEIVERS_RESPONSE.status === 200) {
                    const CONTENT: any = await RECEIVERS_RESPONSE.json();
                    SET_PRODUCT_RECEIVERS(CONTENT?.Receivers);
                } else {
                    const CONTENT: HTTP_ERROR_RESPONSE_INTERFACE = await RECEIVERS_RESPONSE.json();
                    SET_PRODUCT_RECEIVER_ERROR({ErrorCode: RECEIVERS_RESPONSE.status, UserMessage: CONTENT?.UserMessage});
                }

            } catch (e) {
                SET_PRODUCT_RECEIVER_ERROR({ErrorCode: 500, UserMessage: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"});
            }

            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        };

        const delayForResearch = setTimeout(()=>GET_PRODUCT_RECEIVERS(), 1000);
        return ()=>clearTimeout(delayForResearch);


    }, [productReceiversFilter]);

    useEffect(() => {
        return () => {setProductReceiversFilter("")};
    }, []);


    if (PRODUCT_RECEIVER_ERROR) return <ErrorMessageComponent messageText={PRODUCT_RECEIVER_ERROR.UserMessage} />;


    if (!PRODUCT_DATA) return null;


    const ProductReceivers: any = PRODUCT_RECEIVERS?.filter(
        (productReceiver: any) => productReceiver.ReceiverMasterNo?.includes(productReceiversFilter) || productReceiver.ReceiverInfo?.includes(productReceiversFilter)
    ).map((productReceiver: any) =>
        <option key={productReceiver.ReceiverMasterNo} value={productReceiver.ReceiverMasterNo}>{productReceiver.ReceiverInfo}</option>
    );


    return (
        <Row className={"product-receivers-list"} style={{margin: "0 -5px 0 -5px"}}>

            <Col xs={8} className={"compartment-product-receivers-list"}>

                <Form.Label>
                    <span>{`Miejsce dostawy`}</span>
                    {editable ?
                        PRODUCT_RECEIVER_CHANGE_STATUS ?
                        <MdCancel onClick={() => CHANGE_PRODUCT_RECEIVER_CHANGE_STATUS(false)}/>
                        :
                        <MdChangeCircle onClick={() => CHANGE_PRODUCT_RECEIVER_CHANGE_STATUS(true)} />
                    :
                    null
                    }
                </Form.Label>

                <Form.Control
                    as={"select"}
                    value={PRODUCT_RECEIVER}
                    onChange={(e: any) => SET_PRODUCT_RECEIVER(e.target.value)}
                    disabled={!(PRODUCT_RECEIVER_CHANGE_STATUS && editable)}
                >
                    {!PRODUCT_RECEIVER_CHANGE_STATUS && <option value={PRODUCT_DATA?.ReceiverMasterNo}>{PRODUCT_DATA?.ReceiverName || "brak miejsca dostawy"}</option>}
                    {ProductReceivers?.length > 0 ? ProductReceivers : <option value={"BRAK"}>{`brak dostępnych miejsc dostawy`}</option>}
                </Form.Control>

            </Col>

            {PRODUCT_RECEIVER_CHANGE_STATUS &&
	        <Col xs={4} className={"compartment-product-receivers-filter"}>
		        <Form.Label>
			        <span>{`Filtruj`}</span>
		        </Form.Label>
		        <Form.Control
			        value={productReceiversFilter}
			        onChange={(e) => setProductReceiversFilter(e.target.value)}
			        disabled={!(PRODUCT_RECEIVER_CHANGE_STATUS && editable)}
		        />
	        </Col>
            }

        </Row>
    );

};


export default CompartmentProductReceiversComponent;
